<template>
    <li v-if="!menu.cta" class="nav-overlay__item" :class="{ 'nav-overlay__item--active': isActive }">
        
        <a v-if="menu.url == '#'" class="nav-overlay__link" href="#" :class="{ 'nav-overlay__link--null': menu.url == '#'}" v-on:click.prevent.self="onClick">
            {{ menu.title }}

            <Icon name="chevron" />
        </a>
        <a v-else class="nav-overlay__link" :href="menu.url" :class="{ 'nav-overlay__link--null': menu.url == '#'}">
            {{ menu.title }}
        </a>

         <div v-if="children.length" class="nav-overlay__submenu" :class="{'nav-overlay__submenu--active': isActive }">
             <div class="nav-overlay__submenu-inner">      
                 <ul v-if="children.length" class="nav-overlay__submenu-list">
                     <nav-overlay-item-child v-for="child in children" :key="child.order" :child="child"></nav-overlay-item-child>
                 </ul>
             </div>
         </div>
    </li>
</template>

<script>
import _ from 'lodash';
import NavOverlayItemChild from './NavOverlayItemChild.vue';
import Icon from './Icon.vue';

export default {
    name: 'MobileMenuItem',
    components: {
      Icon,
      NavOverlayItemChild
    },
    data() {
        return {
            menu: [],
            children: [],
        };
    },
    methods: {
        onClick(e) {
            e.target.blur();

            this.$emit('click');
        }
    },
    props: ['item', 'isActive'],
    emits: ['enter', 'leave'],
    mounted: function() {
        //initialize this menu item
        this.menu = this.item;

        //set it's children menu items
        var childs = this.item.children;
        this.children = _.sortBy(childs, 'order');
    },
};
</script>